module.exports = __webpack_public_path__ + "static/media/Portrait-10033.9862a5d2.jpg";